// танин баталгаажуулах [choose method]
import useIntl from '@/utils/intl'
import { ArrowForwardIos } from '@mui/icons-material'
import Image from 'next/image'
import React, { FunctionComponent } from 'react'
import { useTheme } from '@/context/ThemeContext'
import { trackNewNumberEvent } from '@/utils/newNumberFlowTracking'

interface Props {
  onChooseEmongolia: (method?: 'emongolia' | 'kyc') => void
  service?: 'digiConsent' | 'newNumber' | 'packageShift' | 'handset' | 'simRecovery'
}

const Step1: FunctionComponent<Props> = ({
  onChooseEmongolia,
  service
}) => {
  const { translate } = useIntl()
  const { theme } = useTheme()

  const showKyc =
    service === 'newNumber' || service === 'simRecovery'

  return (
    <div className='p-8'>
      <span className='text-textHigh font-extrabold text-lg sm:text-2xl'>
        {translate('verify.confirmation')}
      </span>

      <p className='text-textMid text-base sm:text-lg mt-2'>
        {translate('user.confirmInfo')}
      </p>

      <div className='bg-surfaceInverse p-2 mt-4 rounded-t-xl'>
        <div
          onClick={() => {
            if (service === 'newNumber') {
              trackNewNumberEvent('select_verification_method', {
                step_name: 'identity_verification',
                method: 'emongolia'
              })
            }
            onChooseEmongolia('emongolia')
          }}
          className='flex flex-col'
        >
          <div className='flex flex-row p-3 items-center border border-secondarySoftLow rounded-xl bg-surfaceInverse gap-3'>
            <div className='border border-secondarySoftLow rounded-md p-1 shrink-0'>
              <Image
                src='/icons/emongolia-svg.svg'
                alt='profile'
                height={24}
                width={24}
              />
            </div>
            <div className='flex-col flex-grow'>
              <span className='font-bold text-textHigh'>
                {translate('verify.emongolia')}
              </span>
              <p className='flex text-textMid text-xs mt-1'>
                {translate('verify.emongolia.desc')}
              </p>
            </div>
            <ArrowForwardIos fontSize='small' className='text-textMid' sx={{ width: '16px', height: '16px' }} />
          </div>
        </div>
      </div>
      {showKyc && (
        <div className='bg-surfaceInverse p-2 rounded-b-xl'>
          <div
            onClick={() => {
              if (service === 'newNumber') {
                trackNewNumberEvent('select_verification_method', {
                  step_name: 'identity_verification',
                  method: 'face_id'
                })
              }
              onChooseEmongolia('kyc')
            }}
            className='flex flex-col'
          >
            <div className='flex flex-row p-3 items-center border border-secondarySoftLow rounded-xl bg-surfaceInverse gap-3'>
              <div className='border border-secondarySoftLow rounded-md p-1 shrink-0'>
                <Image
                  src='/icons/profile.svg'
                  alt='profile'
                  height={24}
                  width={24}
                  className={theme === 'dark' ? 'invert' : ''}
                  draggable={false}
                />
              </div>
              <div className='flex-col flex-grow'>
                <span className='font-bold text-textHigh'>
                  {translate('verify.kyc.faceRecognition')}
                </span>
                <p className='flex text-textMid text-xs mt-1'>
                  {translate('verify.kyc.faceRecognition.text')}
                </p>
              </div>
              <ArrowForwardIos fontSize='small' className='text-textMid' sx={{ width: '16px', height: '16px' }} />
            </div>
          </div>
        </div>
      )}
    </div>
  )
}
export default Step1
